import { toast } from "react-toastify";

import TimeBlocks from "../../../api/time-blocks";

export const timeBlocks = {
  state: {
    blocks: [],
    loading: false,
  },
  reducers: {
    setBlocks(state, payload) {
      return {
        ...state,
        blocks: payload,
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    clearStore() {
      return {};
    },
    setError(state, payload) {
      return {
        ...state,
        error: {
          message: payload.message,
          data: payload.data
        }
      }
    },
    clearError(state, payload) {
      return {
        ...state,
        error: payload
      }
    }
  },

  effects: (dispatch) => ({
    async loadAsync(payload, rootState) {
      try {
        const { branchId, date, getAllTimeBlocks } = payload;
        this.loading({ loading: true });
        let data = [];
        if (payload) {
          const res = await TimeBlocks.listByBranch(branchId, date, getAllTimeBlocks);
          data = res.data;
        }
        this.setBlocks(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async loadByDateIntervalAsync(payload, rootState) {
      try {
        const { branchId, startDate, endDate } = payload;
        this.loading({ loading: true });
        let data = [];
        if (payload) {
          const res = await TimeBlocks.listByDateInterval(branchId, startDate, endDate);
          data = res.data;
        }
        this.setBlocks(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async loadAvailableByDateAsync(payload, rootState) {
      try {
        const {
          idLoadType,
          idProduct,
          idPlant,
          date,
          clientDocumentNumber,
          transporterCNPJ
        } = payload;

        const { timeBlocks: { blocks } } = rootState;
        this.loading({ loading: true });
        let data = [];

        if(blocks.length) {
          this.setBlocks(data);
        }

        if (payload) {
          const res = await TimeBlocks.listAvailableByDate(
            date,
            idPlant,
            idProduct,
            idLoadType,
            clientDocumentNumber,
            transporterCNPJ
          );
          data = res.data;
        }
        this.setBlocks(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async addAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const { data } = await TimeBlocks.add(payload);
        this.loadAsync({
          branchId: data?.id_branch,
          date: data?.start_date.substring(0, 10),
          end_date: data?.end_date
        });
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return {
          success: false,
          message: error.response.data || "Erro ao adicionar turno.",
        };
      }
      return { success: true, message: "Turno adicionado com sucesso.", messageAux: "Atenção: Caso tenha realizado alguma alteração do Turno/Bloco, favor revisar as Cotas Por Plantas e Cotas por Cliente/Fornecedor no intervalo alterado." };
    },
    async updateAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const { data } = await TimeBlocks.update(payload);
        if(data?.hasScheduling){
         this.setError(data);
         this.loading({ loading: false });
         return false;
        }
        this.loadAsync({
          branchId: data.id_branch,
          date: data.start_date.substring(0, 10),
        });
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return {
          success: false,
          message: error.response.data || "Erro ao atualizar turno.",
        };
      }
      return { success: true, message: "Turno atualizado com sucesso.", messageAux: "Atenção: Caso tenha realizado alguma alteração do Turno/Bloco, favor revisar as Cotas Por Plantas e Cotas por Cliente/Fornecedor no intervalo alterado." };
    },
    async deleteAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const { id, date } = payload;
        const {
          timeBlocks: { blocks },
        } = rootState;
        const response = await TimeBlocks.delete(id, date);
        if(!!response?.data?.hasWarning){
          this.setError(response?.data)
        }
        this.setBlocks(blocks.filter((p) => p.id !== payload.id));
        this.loading({ loading: false });
      } catch (error) {
         this.setError(error.response.data)
         this.loading({ loading: false });
      }
    },
    clearTurns(payload){
      this.setBlocks(payload);
    }
  }),
};
